export default "__VITE_ASSET__d9e48114__"